import { normaliseDynamicComponentName } from 'layout/registry-naming.js';
import React from 'react';
import { IModule } from 'redux-state/layout/types.js';
import { getModuleEager } from './module-build-eager.js';
import { componentWithErrorBoundary } from './module-error.js';

/**
 * Code splitting & Lazy load module using React.lazy rather than cached modules
 * https://reactjs.org/docs/code-splitting.html#reactlazy
 */

export const getModuleComponentWithErrorBoundary = (rawName: string): React.ComponentType<IModule> | undefined => {
  const name = normaliseDynamicComponentName(rawName, 'moduleComponent');
  // ensure we dont need to lazy load ad to run as quick as possible

  if (name) {
    const EagerLoadModule = getModuleEager(name);
    if (EagerLoadModule) {
      return EagerLoadModule;
    }

    const Home = componentWithErrorBoundary(React.lazy(() => import(`lazy/modules.lazy/${name}`)));
    return Home;
  }
  return undefined;
};
